window.fit = window.fit || {};

(function($) {

  fit.footer = function(root) {
    this.root = root;
    this._attach();
  };

  fit.footer.prototype = {
    _attach : function() {
      this.root.find('.js-footer-slide-up').on('click', this._up.bind(this));
    },
    _up : function() {
      $('html, body').animate({
          scrollTop: 0
      }, 300);
    }
  };

  new fit.footer($('.js-footer'))

})(jQuery);
